import { render, staticRenderFns } from "./UserSkillsInventory.vue?vue&type=template&id=831a0aae&scoped=true&"
import script from "./UserSkillsInventory.vue?vue&type=script&lang=js&"
export * from "./UserSkillsInventory.vue?vue&type=script&lang=js&"
import style0 from "./UserSkillsInventory.vue?vue&type=style&index=0&id=831a0aae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831a0aae",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DashboardCard: require('/workspace/components/Dashboard/DashboardCard.vue').default})
